import PropTypes from "prop-types"
import React from "react"

import { statusToken } from "src/components/Badge/status_tokens"

import Badge from "../../../components/Badge"

const LABELS = {
  initialized: "Failed",
  requires_confirmation: "Failed",
  failed: "Failed",
  blocked: "Blocked",
  requires_action: "Action Needed",
  requires_reauthorization: "Action Needed",
  processing: "Verification in Progress",
}

const PaymentMethodStatusBadge = ({ status }) => {
  const label = LABELS[status]
  if (!label) return null

  return (
    <div className="ml-2">
      <Badge color={statusToken(label)} text={label} />
    </div>
  )
}

PaymentMethodStatusBadge.propTypes = {
  status: PropTypes.oneOf([
    "initialized",
    "requires_confirmation",
    "requires_action",
    "requires_reauthorization",
    "processing",
    "succeeded",
    "failed",
    "blocked",
  ]),
}

export default PaymentMethodStatusBadge
